import type { RouteObject } from "react-router-dom";
import { PagesAccountSwitcherUiUiDisplay } from "./Display";
import { PagesAccountSwitcherUiUiResults } from "./Display/Results";
import { PagesAccountSwitcherUiUiModal } from "./Display/Modal";
import { PagesAccountSwitcherUiUiDisplayNew } from "./new";
import { PagesAccountSwitcherUiUiResultsNew } from "./new/Results";

export const PagesAccountSwitcherUiUiRoutes: RouteObject[] = [
  {
    path: "accountSwitcherUiNew",
    element: <PagesAccountSwitcherUiUiDisplayNew />,
    children: [
      {
        path: ":searchValue",
        element: <PagesAccountSwitcherUiUiResultsNew />
      }
    ]
  },
  {
    path: "accountSwitcherUi",
    element: <PagesAccountSwitcherUiUiDisplay />,
    children: [
      {
        path: ":searchValue",
        element: <PagesAccountSwitcherUiUiResults />,
        children: [
          {
            path: ":record",
            element: <PagesAccountSwitcherUiUiModal />
          }
        ]
      }
    ]
  }
];
